
var redemptionSections = new RedemptionTable();
$(window).on('load',() => {
    (()=>{
      $(document).ready(() =>{
        $(document).on("swell:initialized",() => {
          console.log("swell initialized");
          redemptionSections.renderRedemptions(spapi.activeRedemptionOptions);
          new CampaignGrid(swellAPI.getActiveCampaigns()).renderCampaigns();
          
          
        });
  
        $(document).on("swell:setup",() => {
          console.log("swell setup");
          
          redemptionSections.checkLoggedIn(swellAPI.getCustomerDetails());
  
        });
      });
    }).call(this);
  })
  
    //Remove The PopUp Box
  closePopup = () => {
      document.querySelector(".loyalty-tac-container").style.display = "none";
  }
  
  showPopup = () => {
      document.querySelector(".loyalty-tac-container").style.display = "flex";
  }
  
  closePopup()